import React, { useState, useEffect } from 'react';
import { Tags } from 'lucide-react';
import FormModalLayout from '../Common/FormModalLayout';
import Can from '../Common/Can';
import { P } from '../../constants/permissions';

const CategoryModal = ({ category, categories = [], onSubmit, onClose }) => {
  const [formData, setFormData] = useState({ name: '', parent_id: '' });

  useEffect(() => {
    if (category) {
      setFormData({
        name: category.name || '',
        parent_id: category.parent_id || '',
      });
    } else {
      setFormData({ name: '', parent_id: '' });
    }
  }, [category]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      name: formData.name.trim(),
      parent_id: formData.parent_id || undefined,
    };
    onSubmit(payload);
  };

  return (
    <FormModalLayout
      title={category ? 'Editar categoria' : 'Nova categoria'}
      subtitle="Classifique denúncias ambientais em categorias hierárquicas."
      headerIcon={Tags}
      onClose={onClose}
      size="md"
      historyEntityType="complaint_categories"
      historyEntityId={category?.id}
      footer={
        <>
          <button type="button" onClick={onClose} className="btn btn-outline">
            Cancelar
          </button>
          <Can permission={P.COMPLAINT_ACCESS}>
            <button type="submit" form="category-modal-form" className="btn btn-primary">
              {category ? 'Salvar' : 'Criar'}
            </button>
          </Can>
        </>
      }
    >
      <form id="category-modal-form" onSubmit={handleSubmit} className="form-stack">
        <div className="form-group">
          <label htmlFor="cat-name" className="form-label form-label-required">
            Nome
          </label>
          <input
            id="cat-name"
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            className="form-input"
            placeholder="Nome da categoria"
            required
            autoComplete="off"
          />
        </div>
        <div className="form-group">
          <label htmlFor="cat-parent" className="form-label">
            Categoria pai
          </label>
          <select
            id="cat-parent"
            value={formData.parent_id}
            onChange={(e) => setFormData({ ...formData, parent_id: e.target.value })}
            className="form-select"
          >
            <option value="">Nenhuma (raiz)</option>
            {categories
              .filter((c) => !category || c.id !== category.id)
              .map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
          </select>
          <p className="form-help">Opcional. Deixe em branco para categoria de primeiro nível.</p>
        </div>
      </form>
    </FormModalLayout>
  );
};

export default CategoryModal;
